import React, { useContext, useEffect, useRef, useState } from "react";
import "./contactUs.scss";
import "react-phone-input-2/lib/material.css";
import { ContectUsQuerry, fetIpAddress } from "../../utils/Api/api";
import {
  ShimmerLoader,
  ShimmerLoaderwhiteOneLine,
} from "../../utils/loader/ShimmerLoader";
import { cmsPublicContent } from "../../utils/cmscontent/cms";

import useGeoLocation from "../../components/geoLocation/GeoLoaction";
import { Context } from "../../contextApi/contextProvider";
import { toast } from "react-toastify";
import { toastCommonestyle } from "../../utils/Toast";
import { motion, AnimatePresence } from "framer-motion";
import {
  Mail,
  Phone,
  Send,
  CheckCircle2,
  Shield,
  RefreshCw,
  Globe,
  User,
  MessageSquare,
  ChevronDown,
  GlobeIcon,
} from "lucide-react";
// Theme
  export const countries = [
    { code: "af", name: "Afghanistan", dialCode: "+93" },
    { code: "al", name: "Albania", dialCode: "+355" },
    { code: "dz", name: "Algeria", dialCode: "+213" },
    { code: "ad", name: "Andorra", dialCode: "+376" },
    { code: "ao", name: "Angola", dialCode: "+244" },
    { code: "ag", name: "Antigua and Barbuda", dialCode: "+1-268" },
    { code: "ar", name: "Argentina", dialCode: "+54" },
    { code: "am", name: "Armenia", dialCode: "+374" },
    { code: "au", name: "Australia", dialCode: "+61" },
    { code: "at", name: "Austria", dialCode: "+43" },
    { code: "az", name: "Azerbaijan", dialCode: "+994" },
    { code: "bs", name: "Bahamas", dialCode: "+1-242" },
    { code: "bh", name: "Bahrain", dialCode: "+973" },
    { code: "bd", name: "Bangladesh", dialCode: "+880" },
    { code: "bb", name: "Barbados", dialCode: "+1-246" },
    { code: "by", name: "Belarus", dialCode: "+375" },
    { code: "be", name: "Belgium", dialCode: "+32" },
    { code: "bz", name: "Belize", dialCode: "+501" },
    { code: "bj", name: "Benin", dialCode: "+229" },
    { code: "bt", name: "Bhutan", dialCode: "+975" },
    { code: "bo", name: "Bolivia", dialCode: "+591" },
    { code: "ba", name: "Bosnia and Herzegovina", dialCode: "+387" },
    { code: "bw", name: "Botswana", dialCode: "+267" },
    { code: "br", name: "Brazil", dialCode: "+55" },
    { code: "bn", name: "Brunei", dialCode: "+673" },
    { code: "bg", name: "Bulgaria", dialCode: "+359" },
    { code: "bf", name: "Burkina Faso", dialCode: "+226" },
    { code: "bi", name: "Burundi", dialCode: "+257" },
    { code: "kh", name: "Cambodia", dialCode: "+855" },
    { code: "cm", name: "Cameroon", dialCode: "+237" },
    { code: "ca", name: "Canada", dialCode: "+1" },
    { code: "cv", name: "Cape Verde", dialCode: "+238" },
    { code: "cf", name: "Central African Republic", dialCode: "+236" },
    { code: "td", name: "Chad", dialCode: "+235" },
    { code: "cl", name: "Chile", dialCode: "+56" },
    { code: "cn", name: "China", dialCode: "+86" },
    { code: "co", name: "Colombia", dialCode: "+57" },
    { code: "km", name: "Comoros", dialCode: "+269" },
    { code: "cr", name: "Costa Rica", dialCode: "+506" },
    { code: "hr", name: "Croatia", dialCode: "+385" },
    { code: "cu", name: "Cuba", dialCode: "+53" },
    { code: "cy", name: "Cyprus", dialCode: "+357" },
    { code: "cz", name: "Czech Republic", dialCode: "+420" },
    { code: "cd", name: "Democratic Republic of the Congo", dialCode: "+243" },
    { code: "dk", name: "Denmark", dialCode: "+45" },
    { code: "dj", name: "Djibouti", dialCode: "+253" },
    { code: "dm", name: "Dominica", dialCode: "+1-767" },
    { code: "do", name: "Dominican Republic", dialCode: "+1-809" },
    { code: "ec", name: "Ecuador", dialCode: "+593" },
    { code: "eg", name: "Egypt", dialCode: "+20" },
    { code: "sv", name: "El Salvador", dialCode: "+503" },
    { code: "gq", name: "Equatorial Guinea", dialCode: "+240" },
    { code: "er", name: "Eritrea", dialCode: "+291" },
    { code: "ee", name: "Estonia", dialCode: "+372" },
    { code: "sz", name: "Eswatini", dialCode: "+268" },
    { code: "et", name: "Ethiopia", dialCode: "+251" },
    { code: "fj", name: "Fiji", dialCode: "+679" },
    { code: "fi", name: "Finland", dialCode: "+358" },
    { code: "fr", name: "France", dialCode: "+33" },
    { code: "ga", name: "Gabon", dialCode: "+241" },
    { code: "gm", name: "Gambia", dialCode: "+220" },
    { code: "ge", name: "Georgia", dialCode: "+995" },
    { code: "de", name: "Germany", dialCode: "+49" },
    { code: "gh", name: "Ghana", dialCode: "+233" },
    { code: "gr", name: "Greece", dialCode: "+30" },
    { code: "gd", name: "Grenada", dialCode: "+1-473" },
    { code: "gt", name: "Guatemala", dialCode: "+502" },
    { code: "gn", name: "Guinea", dialCode: "+224" },
    { code: "gw", name: "Guinea-Bissau", dialCode: "+245" },
    { code: "gy", name: "Guyana", dialCode: "+592" },
    { code: "ht", name: "Haiti", dialCode: "+509" },
    { code: "hn", name: "Honduras", dialCode: "+504" },
    { code: "hu", name: "Hungary", dialCode: "+36" },
    { code: "is", name: "Iceland", dialCode: "+354" },
    { code: "in", name: "India", dialCode: "+91" },
    { code: "id", name: "Indonesia", dialCode: "+62" },
    { code: "ir", name: "Iran", dialCode: "+98" },
    { code: "iq", name: "Iraq", dialCode: "+964" },
    { code: "ie", name: "Ireland", dialCode: "+353" },
    { code: "il", name: "Israel", dialCode: "+972" },
    { code: "it", name: "Italy", dialCode: "+39" },
    { code: "jm", name: "Jamaica", dialCode: "+1-876" },
    { code: "jp", name: "Japan", dialCode: "+81" },
    { code: "jo", name: "Jordan", dialCode: "+962" },
    { code: "kz", name: "Kazakhstan", dialCode: "+7" },
    { code: "ke", name: "Kenya", dialCode: "+254" },
    { code: "ki", name: "Kiribati", dialCode: "+686" },
    { code: "kw", name: "Kuwait", dialCode: "+965" },
    { code: "kg", name: "Kyrgyzstan", dialCode: "+996" },
    { code: "la", name: "Laos", dialCode: "+856" },
    { code: "lv", name: "Latvia", dialCode: "+371" },
    { code: "lb", name: "Lebanon", dialCode: "+961" },
    { code: "ls", name: "Lesotho", dialCode: "+266" },
    { code: "lr", name: "Liberia", dialCode: "+231" },
    { code: "ly", name: "Libya", dialCode: "+218" },
    { code: "li", name: "Liechtenstein", dialCode: "+423" },
    { code: "lt", name: "Lithuania", dialCode: "+370" },
    { code: "lu", name: "Luxembourg", dialCode: "+352" },
    { code: "mg", name: "Madagascar", dialCode: "+261" },
    { code: "mw", name: "Malawi", dialCode: "+265" },
    { code: "my", name: "Malaysia", dialCode: "+60" },
    { code: "mv", name: "Maldives", dialCode: "+960" },
    { code: "ml", name: "Mali", dialCode: "+223" },
    { code: "mt", name: "Malta", dialCode: "+356" },
    { code: "mh", name: "Marshall Islands", dialCode: "+692" },
    { code: "mr", name: "Mauritania", dialCode: "+222" },
    { code: "mu", name: "Mauritius", dialCode: "+230" },
    { code: "mx", name: "Mexico", dialCode: "+52" },
    { code: "fm", name: "Micronesia", dialCode: "+691" },
    { code: "md", name: "Moldova", dialCode: "+373" },
    { code: "mc", name: "Monaco", dialCode: "+377" },
    { code: "mn", name: "Mongolia", dialCode: "+976" },
    { code: "me", name: "Montenegro", dialCode: "+382" },
    { code: "ma", name: "Morocco", dialCode: "+212" },
    { code: "mz", name: "Mozambique", dialCode: "+258" },
    { code: "mm", name: "Myanmar", dialCode: "+95" },
    { code: "na", name: "Namibia", dialCode: "+264" },
    { code: "nr", name: "Nauru", dialCode: "+674" },
    { code: "np", name: "Nepal", dialCode: "+977" },
    { code: "nl", name: "Netherlands", dialCode: "+31" },
    { code: "nz", name: "New Zealand", dialCode: "+64" },
    { code: "ni", name: "Nicaragua", dialCode: "+505" },
    { code: "ne", name: "Niger", dialCode: "+227" },
    { code: "ng", name: "Nigeria", dialCode: "+234" },
    { code: "kp", name: "North Korea", dialCode: "+850" },
    { code: "mk", name: "North Macedonia", dialCode: "+389" },
    { code: "no", name: "Norway", dialCode: "+47" },
    { code: "om", name: "Oman", dialCode: "+968" },
    { code: "pk", name: "Pakistan", dialCode: "+92" },
    { code: "pw", name: "Palau", dialCode: "+680" },
    { code: "pa", name: "Panama", dialCode: "+507" },
    { code: "pg", name: "Papua New Guinea", dialCode: "+675" },
    { code: "py", name: "Paraguay", dialCode: "+595" },
    { code: "pe", name: "Peru", dialCode: "+51" },
    { code: "ph", name: "Philippines", dialCode: "+63" },
    { code: "pl", name: "Poland", dialCode: "+48" },
    { code: "pt", name: "Portugal", dialCode: "+351" },
    { code: "qa", name: "Qatar", dialCode: "+974" },
    { code: "ro", name: "Romania", dialCode: "+40" },
    { code: "ru", name: "Russia", dialCode: "+7" },
    { code: "rw", name: "Rwanda", dialCode: "+250" },
    { code: "kn", name: "Saint Kitts and Nevis", dialCode: "+1-869" },
    { code: "lc", name: "Saint Lucia", dialCode: "+1-758" },
    {
      code: "vc",
      name: "Saint Vincent and the Grenadines",
      dialCode: "+1-784",
    },
    { code: "ws", name: "Samoa", dialCode: "+685" },
    { code: "sm", name: "San Marino", dialCode: "+378" },
    { code: "st", name: "São Tomé and Príncipe", dialCode: "+239" },
    { code: "sa", name: "Saudi Arabia", dialCode: "+966" },
    { code: "sn", name: "Senegal", dialCode: "+221" },
    { code: "rs", name: "Serbia", dialCode: "+381" },
    { code: "sc", name: "Seychelles", dialCode: "+248" },
    { code: "sl", name: "Sierra Leone", dialCode: "+232" },
    { code: "sg", name: "Singapore", dialCode: "+65" },
    { code: "sk", name: "Slovakia", dialCode: "+421" },
    { code: "si", name: "Slovenia", dialCode: "+386" },
    { code: "sb", name: "Solomon Islands", dialCode: "+677" },
    { code: "so", name: "Somalia", dialCode: "+252" },
    { code: "za", name: "South Africa", dialCode: "+27" },
    { code: "kr", name: "South Korea", dialCode: "+82" },
    { code: "ss", name: "South Sudan", dialCode: "+211" },
    { code: "es", name: "Spain", dialCode: "+34" },
    { code: "lk", name: "Sri Lanka", dialCode: "+94" },
    { code: "sd", name: "Sudan", dialCode: "+249" },
    { code: "sr", name: "Suriname", dialCode: "+597" },
    { code: "se", name: "Sweden", dialCode: "+46" },
    { code: "ch", name: "Switzerland", dialCode: "+41" },
    { code: "sy", name: "Syria", dialCode: "+963" },
    { code: "tw", name: "Taiwan", dialCode: "+886" },
    { code: "tj", name: "Tajikistan", dialCode: "+992" },
    { code: "tz", name: "Tanzania", dialCode: "+255" },
    { code: "th", name: "Thailand", dialCode: "+66" },
    { code: "tl", name: "Timor-Leste", dialCode: "+670" },
    { code: "tg", name: "Togo", dialCode: "+228" },
    { code: "to", name: "Tonga", dialCode: "+676" },
    { code: "tt", name: "Trinidad and Tobago", dialCode: "+1-868" },
    { code: "tn", name: "Tunisia", dialCode: "+216" },
    { code: "tr", name: "Turkey", dialCode: "+90" },
    { code: "tm", name: "Turkmenistan", dialCode: "+993" },
    { code: "tv", name: "Tuvalu", dialCode: "+688" },
    { code: "ug", name: "Uganda", dialCode: "+256" },
    { code: "ua", name: "Ukraine", dialCode: "+380" },
    { code: "ae", name: "United Arab Emirates", dialCode: "+971" },
    { code: "gb", name: "United Kingdom", dialCode: "+44" },
    { code: "us", name: "United States", dialCode: "+1" },
    { code: "uy", name: "Uruguay", dialCode: "+598" },
    { code: "uz", name: "Uzbekistan", dialCode: "+998" },
    { code: "vu", name: "Vanuatu", dialCode: "+678" },
    { code: "ve", name: "Venezuela", dialCode: "+58" },
    { code: "vn", name: "Vietnam", dialCode: "+84" },
    { code: "ye", name: "Yemen", dialCode: "+967" },
    { code: "zm", name: "Zambia", dialCode: "+260" },
    { code: "zw", name: "Zimbabwe", dialCode: "+263" },
  ];
const ContactUs = () => {
  const location = useGeoLocation();
  const [htmlString, setHtmlStr] = useState([]);
  function htmlToPlainText(html: string): string {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }


  // Flag Icon Component
  function FlagIcon({
    countryCode,
    className = "w-6 h-4",
  }: {
    countryCode: string;
    className?: string;
  }) {
    return (
      <img
        src={`https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`}
        alt={`${countryCode} flag`}
        className={`flag-icon-img ${className}`}
        onError={(e) => {
          // Fallback to a colored circle with country code if flag fails to load
          const target = e.target as HTMLImageElement;
          target.style.display = "none";
        }}
      />
    );
  }


  function HeroSection() {
    return (
      <section className="relative flex items-center justify-center overflow-hidden px-4 pt-10 pb-8 md:pt-14 md:pb-10">
        {/* Animated Background */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-[#01044B] via-[#0a0e27] to-[#0209B1]"></div>

          {/* Radial Glows */}
          <motion.div
            className="absolute top-20 left-10 w-[400px] h-[400px] rounded-full blur-3xl opacity-30"
            style={{
              background:
                "radial-gradient(circle, rgba(87, 144, 255, 0.4) 0%, rgba(52, 137, 153, 0) 70%)",
            }}
            animate={{
              scale: [1, 1.2, 1],
              opacity: [0.3, 0.5, 0.3],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
          <motion.div
            className="absolute bottom-20 right-10 w-[350px] h-[350px] rounded-full blur-3xl opacity-30"
            style={{
              background:
                "radial-gradient(circle, rgba(87, 144, 255, 0.4) 0%, rgba(52, 137, 153, 0) 70%)",
            }}
            animate={{
              scale: [1.2, 1, 1.2],
              opacity: [0.2, 0.4, 0.2],
            }}
            transition={{
              duration: 10,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />

          {/* Grid Pattern */}
          <svg className="absolute inset-0 w-full h-full opacity-10">
            <defs>
              <pattern
                id="contact-grid"
                width="40"
                height="40"
                patternUnits="userSpaceOnUse"
              >
                <path
                  d="M 40 0 L 0 0 0 40"
                  fill="none"
                  stroke="rgba(87, 228, 255, 0.3)"
                  strokeWidth="0.5"
                />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#contact-grid)" />
          </svg>
        </div>

        <div className="relative z-10 max-w-4xl w-full">
          <div className="text-center">
            {htmlString[0] ? (
              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.2 }}
                className="text-white mb-3 leading-tight uppercase"
              >
                {htmlString[0]}
                <br />
                <span className="text-cyan-400"> {htmlString[1]}</span>
              </motion.h1>
            ) : (
              <span className="flex justify-center">
                <ShimmerLoader />
              </span>
            )}

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="flex justify-center text-cyan-100/70 text-base md:text-lg max-w-2xl mx-auto mb-6"
            >
              {htmlString[2] ? htmlString[2] : <ShimmerLoader />}
            </motion.p>

            {/* Trust Indicators */}
            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              className="flex justify-center gap-4"
            >
              <TrustBadge icon={Shield} label="Secure" />
              <TrustBadge icon={CheckCircle2} label="Verified" />
              <TrustBadge icon={Globe} label="Global" />
            </motion.div> */}
          </div>
        </div>
      </section>
    );
  }

  function TrustBadge({ icon: Icon, label }: { icon: any; label: string }) {
    return (
      <motion.div
        whileHover={{ scale: 1.05, y: -5 }}
        className="flex flex-col items-center gap-2 bg-cyan-500/5 border border-cyan-500/20 rounded-lg px-3 py-2 backdrop-blur-sm"
      >
        <Icon className="w-6 h-6 text-cyan-400" />
        <span className="text-xs text-cyan-100/70">{label}</span>
      </motion.div>
    );
  }

  const subjectOptions = [
    "General Inquiry",
    "Feedback",
    "Support",
    "Partnership",
    "Other",
  ];
  const replyOptions = ["Email", "Phone", "No Reply Needed"];

  // Types (adjust or import from your types file)
  type FormData = {
    name: string;
    email: string;
    country: string;
    code: string;
    phoneCountry: string;
    phone: string;
    subject: string;
    replyVia: string;
    notes: string;
  };

  type FormErrors = Partial<Record<keyof FormData, string>>;

  // Dummy placeholders (remove when you import real values)

  function ContactFormSection() {
    type RotationTarget = {
      id: "north" | "north_east" | "east" | "south_west";
      label: string;
      angle: number;
    };

    const [formData, setFormData] = useState<FormData>({
      name: "",
      email: "",
      country: "au",
      code: "+61",
      phoneCountry: "au",
      phone: "",
      subject: "",
      replyVia: "",
      notes: "",
    });

    const [errors, setErrors] = useState<FormErrors>({});
    const MAX_LENGTH = 500;
    const location = useGeoLocation();
    const formStartTimeRef = useRef<number>(Date.now());
    const [captchaError, setCaptchaError] = useState("");
    const [captchaVerified, setCaptchaVerified] = useState(false);
    const [showHumanVerification, setShowHumanVerification] = useState(false);
    const [pendingSubmission, setPendingSubmission] = useState(false);
    const [website, setWebsite] = useState("");
    const [rotationVerified, setRotationVerified] = useState(false);
    const [showRotateModal, setShowRotateModal] = useState(false);
    const [rotationAngle, setRotationAngle] = useState(0);

    const rotationTargets: RotationTarget[] = [
      { id: "north", label: "North", angle: 270 },
      { id: "north_east", label: "North-East", angle: 315 },
      { id: "east", label: "East", angle: 0 },
      { id: "south_west", label: "South-West", angle: 135 },
    ];

    const [targetRotation, setTargetRotation] = useState<RotationTarget>(
      rotationTargets[0],
    );

    const getSecureRandomInt = (min: number, max: number) => {
      const range = max - min + 1;
      const random = new Uint32Array(1);
      window.crypto.getRandomValues(random);
      return min + (random[0] % range);
    };

    const pickRandomTarget = () =>
      rotationTargets[getSecureRandomInt(0, rotationTargets.length - 1)];

    const { userLoginData } = useContext(Context);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [showCountryDropdown, setShowCountryDropdown] = useState(false);
    const [showPhoneCountryDropdown, setShowPhoneCountryDropdown] =
      useState(false);
    const [showSubjectDropdown, setShowSubjectDropdown] = useState(false);
    const [showReplyDropdown, setShowReplyDropdown] = useState(false);

    const [countrySearchTerm, setCountrySearchTerm] = useState("");
    const [phoneCountrySearchTerm, setPhoneCountrySearchTerm] = useState("");
    const [subjectSearch, setSubjectSearch] = useState("");
    const [replySearch, setReplySearch] = useState("");

    const countryDropdownRef = useRef<HTMLDivElement | null>(null);
    const phoneCountryDropdownRef = useRef<HTMLDivElement | null>(null);
    const subjectDropdownRef = useRef<HTMLDivElement | null>(null);
    const replyDropdownRef = useRef<HTMLDivElement | null>(null);

    const ref = useRef<HTMLDivElement | null>(null);

    const containsMaliciousCharacters = (val: string) =>
      ["<", ">", '"', "'", "`", "=", "{", "}", "(", ")"].some((char) =>
        val.includes(char),
      ) || val.toLowerCase().includes("script");

    useEffect(() => {
      function handleClickOutside(e: MouseEvent) {
        const target = e.target as Node;
        if (
          countryDropdownRef.current &&
          !countryDropdownRef.current.contains(target)
        ) {
          setShowCountryDropdown(false);
        }
        if (
          phoneCountryDropdownRef.current &&
          !phoneCountryDropdownRef.current.contains(target)
        ) {
          setShowPhoneCountryDropdown(false);
        }
        if (
          subjectDropdownRef.current &&
          !subjectDropdownRef.current.contains(target)
        ) {
          setShowSubjectDropdown(false);
        }
        if (
          replyDropdownRef.current &&
          !replyDropdownRef.current.contains(target)
        ) {
          setShowReplyDropdown(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () =>
        document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const filteredCountries = countries.filter(
      (c) =>
        c.name.toLowerCase().includes(countrySearchTerm.toLowerCase()) ||
        c.code.toLowerCase().includes(countrySearchTerm.toLowerCase()) ||
        c.dialCode.includes(countrySearchTerm),
    );

    const filteredPhoneCountries = countries.filter(
      (c) =>
        c.name.toLowerCase().includes(phoneCountrySearchTerm.toLowerCase()) ||
        c.dialCode.includes(phoneCountrySearchTerm),
    );

    const filteredSubjects = subjectOptions.filter((s) =>
      s.toLowerCase().includes(subjectSearch.toLowerCase()),
    );
    const filteredReplies = replyOptions.filter((r) =>
      r.toLowerCase().includes(replySearch.toLowerCase()),
    );

    const normalizeDeg = (deg: number) => {
      const normalized = deg % 360;
      return normalized < 0 ? normalized + 360 : normalized;
    };

    const angleDistance = (a: number, b: number) => {
      const diff = Math.abs(normalizeDeg(a) - normalizeDeg(b));
      return Math.min(diff, 360 - diff);
    };

    const openRotateChallenge = () => {
      setTargetRotation(pickRandomTarget());
      setRotationAngle(getSecureRandomInt(0, 359));
      setShowRotateModal(true);
      setCaptchaError("");
    };

    const confirmRotation = () => {
      const offset = angleDistance(rotationAngle, targetRotation.angle);
      if (offset <= 10) {
        setRotationVerified(true);
        setCaptchaVerified(true);
        setCaptchaError("");
        setShowRotateModal(false);
      } else {
        setCaptchaVerified(false);
        setCaptchaError(
          `Almost there. Rotate a bit more (off by ${Math.round(offset)}deg).`,
        );
      }
    };

    const resetCaptcha = () => {
      setWebsite("");
      setRotationVerified(false);
      setShowRotateModal(false);
      setRotationAngle(0);
      setTargetRotation(rotationTargets[0]);
      setCaptchaVerified(false);
      setPendingSubmission(false);
      setCaptchaError("");
      formStartTimeRef.current = Date.now();
    };

    useEffect(() => {
      if (captchaVerified && pendingSubmission) {
        void submitVerifiedForm();
      }
    }, [captchaVerified, pendingSubmission]);

    const verifyCaptcha = () => {
      if (website.trim()) {
        setCaptchaVerified(false);
        setCaptchaError("Verification failed. Please refresh and try again.");
        return false;
      }

      const elapsedMs = Date.now() - formStartTimeRef.current;
      if (elapsedMs < 4000) {
        setCaptchaVerified(false);
        setCaptchaError("Please take a moment before submitting.");
        return false;
      }

      if (!rotationVerified) {
        setCaptchaVerified(false);
        setCaptchaError("Please complete the rotate verification challenge.");
        return false;
      }

      setCaptchaVerified(true);
      setCaptchaError("");
      return true;
    };

    const handleChange = (
      e: React.ChangeEvent<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
      >,
    ) => {
      const { name, value } = e.target as HTMLInputElement;
      setFormData((p) => ({ ...p, [name]: value }));
      setErrors((p) => ({ ...p, [name]: "" }));
    };

    const validateField = (key: keyof FormData): string | "" => {
      const val = (formData[key] as string) || "";

      // Helper functions (NO REGEX)
      const isOnlyNumbers = (str: string) => {
        if (!str) return false;
        for (let i = 0; i < str.length; i++) {
          const c = str[i];
          if (c < "0" || c > "9") return false;
        }
        return true;
      };

      const isValidEmail = (str: string) => {
        if (!str.includes("@")) return false;

        const parts = str.split("@");
        if (parts.length !== 2) return false;

        const local = parts[0];
        const domain = parts[1];

        // Basic checks
        if (!local || !domain) return false;
        if (!domain.includes(".")) return false;

        const domainParts = domain.split(".");
        if (domainParts.some((d) => !d)) return false; // handle ".."

        return true;
      };

      const containsMaliciousCharacters = (str: string) => {
        const badChars = ["<", ">", "{", "}", "[", "]", "`", "$"];
        return badChars.some((c) => str.includes(c));
      };

      switch (key) {
        case "name":
          if (!val.trim()) return "Name is required";
          if (val.trim().length < 3)
            return "Name must be at least 3 characters";
          if (isOnlyNumbers(val)) return "Name cannot be only numbers";
          if (containsMaliciousCharacters(val))
            return "Invalid input detected. Please remove special characters.";
          return "";

        case "email":
          if (!val.trim()) return "Email is required";
          if (!isValidEmail(val)) return "Please enter a valid email address";
          if (containsMaliciousCharacters(val))
            return "Invalid input detected. Please remove special characters.";
          return "";

        case "country":
          if (!val.trim()) return "Country is required";
          return "";

        case "phone":
          if (!val.trim()) return "Phone number is required";
          if (!isOnlyNumbers(val)) return "Phone must contain only digits";
          // allow only digits (no +, no spaces, no country code)
          for (let i = 0; i < val.length; i++) {
            const ch = val[i];
            if (ch < "0" || ch > "9") {
              return "Only numbers allowed (no + or country code)";
            }
          }
          // length check 7–15 digits
          if (val.length < 7 || val.length > 15) {
            return "Phone number must be 7–15 digits";
          }
          return "";

        case "subject":
          if (!val.trim()) return "Please select a subject";
          return "";

        case "replyVia":
          if (!val.trim()) return "Please select a reply method";
          return "";

        case "notes":
          if (!val.trim()) return "Notes is required";
          if (val.trim().length < 10)
            return "Notes must be at least 10 characters";
          if (val.length > MAX_LENGTH)
            return `Notes should not exceed ${MAX_LENGTH} characters`;
          if (containsMaliciousCharacters(val))
            return "Invalid input detected. Please remove special characters.";
          return "";

        default:
          return "";
      }
    };

    const validateAll = (): boolean => {
      const temp: FormErrors = {};
      (Object.keys(formData) as (keyof FormData)[]).forEach((k) => {
        const msg = validateField(k);
        if (msg) temp[k] = msg;
      });

      setErrors(temp);
      return Object.keys(temp).length === 0;
    };
    const fetchIpAddress = async (): Promise<string | null> => {
      try {
        const { data } = await fetIpAddress();
        if (typeof data === "string") {
          const ip = data.trim();
          return ip && ip.toLowerCase() !== "null" ? ip : null;
        }

        if (data && typeof data === "object") {
          const ip = String(
            (data as any).ip_address ?? (data as any).ip ?? "",
          ).trim();
          return ip && ip.toLowerCase() !== "null" ? ip : null;
        }

        return null;
      } catch (error) {
        return null;
      }
    };
    const handleBlur = (field: keyof FormData) => {
      const message = validateField(field);
      setErrors((p) => ({ ...p, [field]: message }));
    };

    const submitVerifiedForm = async () => {
      if (isSubmitting) return;
      setPendingSubmission(false);

      if (!verifyCaptcha()) {
        return;
      }

      setIsSubmitting(true);
      try {
        const ipAddress = await fetchIpAddress();
        if (!ipAddress) {
          toast.error(
            "Unable to verify your IP address. Please check your network and try again.",
            toastCommonestyle as any,
          );
          return;
        }

        const payload = {
          ip_address: ipAddress,
          latitude: location?.coordinates?.lat ?? null,
          longitude: location?.coordinates?.lng ?? null,
          name: formData.name,
          email: formData.email,
          phone: `${formData.code}-${formData.phone}`,
          country: formData.country,
          subject: formData.subject,
          message: formData.notes,
          reply_via: formData.replyVia,
        };

        const { data } = await ContectUsQuerry(payload);

        if (data?.status === 200) {
          toast.success(
            "Form submitted successfully!",
            toastCommonestyle as any,
          );
          setErrors({});
          setIsSubmitted(true);
          setFormData({
            name: "",
            email: "",
            country: "",
            code: "AU",
            phoneCountry: "AU",
            phone: "",
            subject: "",
            replyVia: "",
            notes: "",
          });
          resetCaptcha();
          setShowHumanVerification(false);
        } else {
          toast.error(
            "Submission failed. Please try again later.",
            toastCommonestyle as any,
          );
        }
      } catch (err) {
        console.error(err);
        toast.error("Error submitting form.", toastCommonestyle as any);
      } finally {
        setIsSubmitting(false);
      }
    };

    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();

      if (!validateAll()) {
        setShowHumanVerification(false);
        return;
      }

      setShowHumanVerification(true);
      setPendingSubmission(true);
      setCaptchaError("");
      openRotateChallenge();
    };

    const selectCountry = (country: {
      code: string;
      name: string;
      dialCode: string;
    }) => {
      setFormData((p) => ({
        ...p,
        country: country.code,
        code: country.dialCode,
        phoneCountry: country.code,
      }));
      setShowCountryDropdown(false);
      setCountrySearchTerm("");
      setErrors((p) => ({ ...p, country: "" }));
    };

    const selectPhoneCountry = (country: {
      code: string;
      name: string;
      dialCode: string;
    }) => {
      setFormData((p) => ({
        ...p,
        phoneCountry: country.code,
        code: country.dialCode,
        country: country.code,
      }));
      setShowPhoneCountryDropdown(false);
      setPhoneCountrySearchTerm("");
    };

    const selectSubject = (s: string) => {
      setFormData((p) => ({ ...p, subject: s }));
      setShowSubjectDropdown(false);
      setSubjectSearch("");
      setErrors((p) => ({ ...p, subject: "" }));
    };

    const selectReply = (r: string) => {
      setFormData((p) => ({ ...p, replyVia: r }));
      setShowReplyDropdown(false);
      setReplySearch("");
      setErrors((p) => ({ ...p, replyVia: "" }));
    };

    return (
      <section ref={ref} className="relative px-4 pt-8 pb-12 bg-white md:pt-10 md:pb-14">
        {/* Background decorations (kept) */}
        <motion.div
          className="absolute top-20 -left-20 w-64 h-64 bg-cyan-100/40 rounded-full blur-3xl"
          animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
          className="absolute bottom-20 -right-20 w-80 h-80 bg-blue-100/30 rounded-full blur-3xl"
          animate={{ scale: [1.2, 1, 1.2], opacity: [0.2, 0.4, 0.2] }}
          transition={{ duration: 10, repeat: Infinity, ease: "easeInOut" }}
        />

        <div className="max-w-5xl mx-auto relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-6"
          >
            {htmlString[3] ? (
              <h2 className="text-gray-900 mb-2">
                {htmlString[3]}{" "}
                <span className="text-cyan-600">{htmlString[4]}</span>
              </h2>
            ) : (
              <ShimmerLoaderwhiteOneLine />
            )}
            <div className="w-24 h-1 bg-cyan-500 mx-auto mb-4" />
            <p className="flex justify-center  text-gray-600 leading-relaxed max-w-3xl mx-auto">
              {htmlString[5] ? htmlString[5] : <ShimmerLoader />}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative max-w-3xl mx-auto"
          >
            <motion.div
              className="relative bg-white rounded-2xl shadow-2xl p-6 md:p-8 border border-gray-100 overflow-hidden"
              whileHover={{
                boxShadow: "0 25px 50px -12px rgba(6, 182, 212, 0.25)",
              }}
              transition={{ duration: 0.3 }}
            >
              <motion.div
                className="absolute inset-0 opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(90deg, transparent, rgba(6, 182, 212, 0.1), transparent)",
                  backgroundSize: "200% 100%",
                }}
                animate={{ backgroundPosition: ["0% 0%", "200% 0%"] }}
                transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
              />

              <div className="ticca-form-wrapper">
                <form
                  onSubmit={handleSubmit}
                  className="space-y-4 relative z-10"
                >
                  <input
                    type="text"
                    name="website"
                    autoComplete="off"
                    tabIndex={-1}
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                    className="hidden"
                    aria-hidden="true"
                  />

                  {/* name + email */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Full Name */}
                    <div className="relative group">
                      <div className="absolute left-3 !translate-y-full flex items-center text-cyan-500 opacity-70 group-focus-within:opacity-100 transition-opacity pointer-events-none">
                        <User className="w-4 h-4" />
                      </div>

                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        onBlur={() => handleBlur("name")}
                        placeholder="Full Name"
                        className={`w-full h-[46px] pl-10 pr-4 bg-gray-50 border ${
                          errors.name ? "border-red-500" : "border-gray-200"
                        } rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 text-gray-700 placeholder-gray-400 text-sm`}
                      />

                      {errors.name && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.name}
                        </p>
                      )}
                    </div>

                    {/* Email */}
                    <div className="relative group">
                      <div className="absolute left-3 !translate-y-full flex items-center text-cyan-500 opacity-70 group-focus-within:opacity-100 transition-opacity pointer-events-none">
                        <Mail className="w-4 h-4" />
                      </div>

                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        onBlur={() => handleBlur("email")}
                        placeholder="Email Address"
                        className={`w-full h-[46px] pl-10 pr-4 bg-gray-50 border ${
                          errors.email ? "border-red-500" : "border-gray-200"
                        } rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 text-gray-700 placeholder-gray-400 text-sm`}
                      />

                      {errors.email && (
                        <p className="text-red-500 text-xs mt-1">
                          {errors.email}
                        </p>
                      )}
                    </div>
                  </div>

                  {/* Country Field */}
                  <div className="relative" ref={countryDropdownRef}>
                    <div className="absolute left-3  !translate-y-full flex items-center text-cyan-500 opacity-70 z-10 pointer-events-none">
                      <GlobeIcon className="w-4 h-4" />
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setShowCountryDropdown((s) => !s);
                        setCountrySearchTerm("");
                      }}
                      className={`w-full pl-10 pr-10 py-2.5 bg-gray-50 border ${
                        errors.country ? "border-red-500" : "border-gray-200"
                      } rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300 text-gray-700 text-sm text-left flex items-center gap-2`}
                    >
                      {formData.country ? (
                        <>
                          <FlagIcon
                            countryCode={formData.country}
                            className="w-6 h-4 flex-shrink-0"
                          />
                          <span className="truncate">
                            {countries.find((c) => c.code === formData.country)
                              ?.name ?? formData.country}
                          </span>
                        </>
                      ) : (
                        <span className="text-gray-400">Select Country</span>
                      )}
                    </button>
                    <div className="absolute !translate-y-full right-3 flex items-center pointer-events-none text-gray-400">
                      <ChevronDown className="w-4 h-4" />
                    </div>

                    <AnimatePresence>
                      {showCountryDropdown && (
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -10 }}
                          className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-64 overflow-hidden z-50"
                        >
                          <div className="sticky top-0 bg-white border-b border-gray-200 p-2">
                            <input
                              type="text"
                              value={countrySearchTerm}
                              onChange={(e) =>
                                setCountrySearchTerm(e.target.value)
                              }
                              placeholder="Search country..."
                              className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>

                          <div className="overflow-y-auto max-h-52">
                            {filteredCountries.map((country) => (
                              <button
                                key={country.code}
                                type="button"
                                onClick={() => selectCountry(country)}
                                className="w-full px-4 py-2.5 text-left hover:bg-cyan-50 transition-colors flex items-center gap-3 text-sm border-b border-gray-50 last:border-0"
                              >
                                <FlagIcon
                                  countryCode={country.code}
                                  className="w-6 h-4 flex-shrink-0"
                                />
                                <span className="text-gray-700 flex-1">
                                  {country.name}
                                </span>
                                <span className="text-gray-400 text-xs uppercase">
                                  {country.code}
                                </span>
                              </button>
                            ))}
                            {filteredCountries.length === 0 && (
                              <div className="px-4 py-8 text-center text-gray-400 text-sm">
                                No countries found
                              </div>
                            )}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                    {errors.country && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.country}
                      </p>
                    )}
                  </div>

                  {/* Phone */}
                  <div className="relative">
                    <div className="flex gap-2">
                      <div
                        className="relative w-36"
                        ref={phoneCountryDropdownRef}
                      >
                        <button
                          type="button"
                          onClick={() => {
                            setShowPhoneCountryDropdown((s) => !s);
                            setPhoneCountrySearchTerm("");
                          }}
                          className="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300 text-gray-700 text-sm flex items-center gap-2 justify-between"
                        >
                          <div className="flex items-center gap-2">
                            <FlagIcon
                              countryCode={formData.phoneCountry || "US"}
                              className="w-6 h-4 flex-shrink-0"
                            />
                            <span className="text-xs font-medium">
                              {countries.find(
                                (c) => c.code === formData.phoneCountry,
                              )?.dialCode ?? "+61"}
                            </span>
                          </div>
                          <ChevronDown className="w-3 h-3 text-gray-400 flex-shrink-0" />
                        </button>

                        <AnimatePresence>
                          {showPhoneCountryDropdown && (
                            <motion.div
                              initial={{ opacity: 0, y: -10 }}
                              animate={{ opacity: 1, y: 0 }}
                              exit={{ opacity: 0, y: -10 }}
                              className="absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-64 overflow-hidden z-50 w-72"
                            >
                              <div className="sticky top-0 bg-white border-b border-gray-200 p-2">
                                <input
                                  type="text"
                                  value={phoneCountrySearchTerm}
                                  onChange={(e) =>
                                    setPhoneCountrySearchTerm(e.target.value)
                                  }
                                  placeholder="Search country or code..."
                                  className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </div>
                              <div className="overflow-y-auto max-h-52">
                                {filteredPhoneCountries.map((country) => (
                                  <button
                                    key={country.code}
                                    type="button"
                                    onClick={() => selectPhoneCountry(country)}
                                    className="w-full px-3 py-2.5 text-left hover:bg-cyan-50 transition-colors flex items-center gap-3 text-sm border-b border-gray-50 last:border-0"
                                  >
                                    <FlagIcon
                                      countryCode={country.code}
                                      className="w-6 h-4 flex-shrink-0"
                                    />
                                    <span className="text-gray-700 flex-1 truncate">
                                      {country.name}
                                    </span>
                                    <span className="text-cyan-600 text-xs font-medium flex-shrink-0">
                                      {country.dialCode}
                                    </span>
                                  </button>
                                ))}
                                {filteredPhoneCountries.length === 0 && (
                                  <div className="px-4 py-8 text-center text-gray-400 text-sm">
                                    No countries found
                                  </div>
                                )}
                              </div>
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </div>

                      <div className="relative flex-1 group">
                        <div className="absolute left-3  !translate-y-full flex items-center text-cyan-500 opacity-70 group-focus-within:opacity-100 transition-opacity z-10 pointer-events-none">
                          <Phone className="w-4 h-4" />
                        </div>
                        <input
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          onBlur={() => handleBlur("phone")}
                          placeholder="Phone Number"
                          className={`w-full pl-10 pr-4 py-2.5 bg-gray-50 border ${
                            errors.phone ? "border-red-500" : "border-gray-200"
                          } rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300 text-gray-700 placeholder-gray-400 text-sm`}
                        />
                        {errors.phone && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.phone}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Subject Field */}
                  <div className="relative" ref={subjectDropdownRef}>
                    <div className="absolute left-3  !translate-y-full flex items-center text-cyan-500 opacity-70 group-focus-within:opacity-100 transition-opacity z-10 pointer-events-none">
                      <MessageSquare className="w-4 h-4" />
                    </div>
                    <button
                      type="button"
                      onClick={() => {
                        setShowSubjectDropdown((s) => !s);
                        setSubjectSearch("");
                      }}
                      className={`w-full pl-10 pr-10 py-2.5 bg-gray-50 border ${
                        errors.subject ? "border-red-500" : "border-gray-200"
                      } rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300 text-gray-700 text-sm text-left flex items-center gap-2`}
                    >
                      {formData.subject ? (
                        <span>{formData.subject}</span>
                      ) : (
                        <span className="text-gray-400">Select Subject</span>
                      )}
                    </button>
                    <div className="absolute inset-y-0 right-3 flex items-center pointer-events-none text-gray-400">
                      <ChevronDown className="w-4 h-4" />
                    </div>

                    <AnimatePresence>
                      {showSubjectDropdown && (
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -10 }}
                          className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-64 overflow-hidden z-50"
                        >
                          <div className="sticky top-0 bg-white border-b border-gray-200 p-2">
                            <input
                              type="text"
                              value={subjectSearch}
                              onChange={(e) => setSubjectSearch(e.target.value)}
                              placeholder="Search subject..."
                              className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500"
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>

                          <div className="overflow-y-auto max-h-52">
                            {filteredSubjects.map((s) => (
                              <button
                                key={s}
                                type="button"
                                onClick={() => selectSubject(s)}
                                className="w-full px-4 py-2.5 text-left hover:bg-cyan-50 transition-colors flex items-center gap-3 text-sm border-b border-gray-50 last:border-0"
                              >
                                <span className="text-gray-700 flex-1">
                                  {s}
                                </span>
                              </button>
                            ))}
                            {filteredSubjects.length === 0 && (
                              <div className="px-4 py-8 text-center text-gray-400 text-sm">
                                No subjects found
                              </div>
                            )}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                    {errors.subject && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.subject}
                      </p>
                    )}
                  </div>

                  {/* Notes */}
                  <div className="relative group">
                    <textarea
                      name="notes"
                      value={formData.notes}
                      onChange={handleChange}
                      onBlur={() => handleBlur("notes")}
                      placeholder="Your Message"
                      rows={4}
                      required
                      className={`w-full px-4 py-3 bg-gray-50 border ${
                        errors.notes ? "border-red-500" : "border-gray-200"
                      } rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300 text-gray-700 placeholder-gray-400 resize-none text-sm`}
                    />
                    {errors.notes && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.notes}
                      </p>
                    )}
                  </div>

                  {/* Reply Via */}
                  <div className="relative" ref={replyDropdownRef}>
                    <button
                      type="button"
                      onClick={() => {
                        setShowReplyDropdown((s) => !s);
                        setReplySearch("");
                      }}
                      className={`w-full px-4 py-2.5 bg-gray-50 border ${
                        errors.replyVia ? "border-red-500" : "border-gray-200"
                      } rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent transition-all duration-300 text-gray-700 appearance-none cursor-pointer text-sm text-left flex items-center justify-between`}
                    >
                      <span
                        className={`${formData.replyVia ? "" : "text-gray-400"}`}
                      >
                        {formData.replyVia || "Reply via"}
                      </span>
                      <ChevronDown className="w-4 h-4 text-gray-400" />
                    </button>

                    <AnimatePresence>
                      {showReplyDropdown && (
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -10 }}
                          className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-[8rem] overflow-hidden z-50"
                        >
                          <div className="overflow-y-auto max-h-[8rem] Z-10 mb-[10px]">
                            {filteredReplies.map((r) => (
                              <button
                                key={r}
                                type="button"
                                onClick={() => selectReply(r)}
                                className="w-full px-4 py-2.5 text-left hover:bg-cyan-50 transition-colors text-sm border-b border-gray-50 last:border-0"
                              >
                                <span className="text-gray-700">{r}</span>
                              </button>
                            ))}
                            {filteredReplies.length === 0 && (
                              <div className="px-4 py-8 text-center text-gray-400 text-sm">
                                No options found
                              </div>
                            )}
                          </div>
                        </motion.div>
                      )}
                    </AnimatePresence>
                    {errors.replyVia && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.replyVia}
                      </p>
                    )}
                  </div>

                  {/* Human Verification */}
                  {showHumanVerification && (
                  <div className="rounded-xl border border-cyan-100 bg-gradient-to-r from-cyan-50 to-blue-50 p-4">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <div className="flex items-center gap-2">
                          <Shield className="h-4 w-4 text-cyan-700" />
                          <p className="text-sm font-semibold text-gray-800">
                            Human Verification
                          </p>
                        </div>
                        <p className="mt-1 text-xs text-gray-600">
                          Rotate the arrow to match the target direction.
                        </p>
                      </div>
                      {captchaVerified ? (
                        <span className="inline-flex items-center gap-1 rounded-full bg-green-100 px-2.5 py-1 text-xs font-medium text-green-700">
                          <CheckCircle2 className="h-3.5 w-3.5" /> Verified
                        </span>
                      ) : (
                        <span className="inline-flex items-center gap-1 rounded-full bg-amber-100 px-2.5 py-1 text-xs font-medium text-amber-700">
                          <Shield className="h-3.5 w-3.5" /> Pending
                        </span>
                      )}
                    </div>

                    <div className="mt-3 rounded-lg border border-cyan-200 bg-white p-3">
                      <div className="space-y-3">
                        <button
                          type="button"
                          onClick={openRotateChallenge}
                          className={`w-full rounded-lg px-4 py-2.5 text-sm font-medium text-white transition-all ${
                            rotationVerified
                              ? "bg-green-600"
                              : "bg-cyan-600 hover:bg-cyan-700"
                          }`}
                        >
                          {rotationVerified
                            ? "Human verified"
                            : "Open Rotate Verification"}
                        </button>
                        <p className="text-xs text-gray-500">
                          Use mouse or touch slider to align arrow. This is OCR-resistant and modern.
                        </p>
                      </div>

                      <button
                        type="button"
                        onClick={resetCaptcha}
                        className="mt-3 inline-flex h-[42px] items-center justify-center gap-1 rounded-lg border border-cyan-200 bg-white px-3 text-sm font-medium text-cyan-700 transition-colors hover:bg-cyan-100"
                        title="Reset verification"
                      >
                        <RefreshCw className="h-4 w-4" /> Reset Challenge
                      </button>
                    </div>
                    {captchaError && (
                      <p className="mt-2 text-xs text-red-600">{captchaError}</p>
                    )}
                  </div>
                  )}

                  {showRotateModal && (
                    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-900/70 p-4">
                      <div className="w-full max-w-[520px] rounded-2xl bg-white p-4 shadow-2xl md:p-6">
                        <div className="mb-3 flex items-center justify-between">
                          <h3 className="text-base font-semibold text-gray-800">
                            Rotate To Verify
                          </h3>
                          <button
                            type="button"
                            onClick={() => setShowRotateModal(false)}
                            className="rounded-md border border-gray-200 px-3 py-1 text-xs text-gray-600 hover:bg-gray-50"
                          >
                            Close
                          </button>
                        </div>
                        <p className="mb-3 text-sm text-gray-700">
                          Align the arrow to: <span className="font-semibold">{targetRotation.label}</span>
                        </p>

                        <div className="rounded-xl border border-cyan-100 bg-slate-50 p-4">
                          <div className="relative mx-auto mb-4 h-44 w-44 rounded-full border-4 border-cyan-200 bg-white shadow-inner">
                            <div className="absolute left-1/2 top-1/2 h-[2px] w-16 origin-left bg-amber-500"
                              style={{ transform: `translateY(-50%) rotate(${targetRotation.angle}deg)` }}
                            />
                            <div className="absolute left-1/2 top-1/2 h-[2px] w-16 origin-left bg-cyan-700"
                              style={{ transform: `translateY(-50%) rotate(${rotationAngle}deg)` }}
                            />
                            <div className="absolute left-1/2 top-1/2 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-cyan-900" />
                            <span className="absolute left-1/2 top-2 -translate-x-1/2 text-[10px] font-semibold text-gray-500">N</span>
                            <span className="absolute bottom-2 left-1/2 -translate-x-1/2 text-[10px] font-semibold text-gray-500">S</span>
                            <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[10px] font-semibold text-gray-500">W</span>
                            <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] font-semibold text-gray-500">E</span>
                          </div>

                          <input
                            type="range"
                            min={0}
                            max={359}
                            value={Math.round(rotationAngle)}
                            onChange={(e) => setRotationAngle(Number(e.target.value))}
                            className="w-full accent-cyan-600"
                          />

                          <div className="mt-3 flex gap-2">
                            <button
                              type="button"
                              onClick={confirmRotation}
                              className="flex-1 rounded-lg bg-cyan-600 px-3 py-2 text-sm font-medium text-white hover:bg-cyan-700"
                            >
                              Verify Alignment
                            </button>
                            <button
                              type="button"
                              onClick={openRotateChallenge}
                              className="rounded-lg border border-gray-200 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
                            >
                              New Target
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full py-3 rounded-xl flex items-center justify-center gap-2 text-white transition-all ${
                      isSubmitting
                        ? "bg-cyan-300 cursor-not-allowed"
                        : "bg-cyan-600 hover:bg-cyan-700"
                    }`}
                  >
                    {isSubmitting ? (
                      <svg
                        className="w-5 h-5 animate-spin"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M4 12a8 8 0 018-8v0"
                        />
                      </svg>
                    ) : (
                      <Send className="w-5 h-5" />
                    )}

                    {isSubmitting ? "Sending..." : "Send Message"}
                  </button>
                </form>
              </div>
            </motion.div>

          </motion.div>
        </div>
      </section>
    );
  }

  // Form submit handler

  useEffect(() => {
    window.scrollTo(0, 0);
    if (location.coordinates?.lat && location.coordinates?.lng) {
      const fetchCmsContent = async () => {
        const response = await cmsPublicContent({
          post_id: "6927",
          lat: location.coordinates.lat,
          log: location.coordinates.lng,
        });
        const textPages = response?.map((html: string) =>
          htmlToPlainText(html).trim(),
        );

        setHtmlStr(textPages);
      };

      fetchCmsContent();
    }
    document.title = "TICCA | Contact";
  }, []);
  // Fetch countries and CMS content

  return (
    <div className="bg-[#0a0e27] w-full mt-[50px] overflow-hidden">
      {/* Compact Hero Section */}
      <HeroSection />

      {/* Contact Content Section */}
      <ContactFormSection />
    </div>
  );
};

export default ContactUs;
